<template>
    <div>
        <validation-observer ref="listForm">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <validation-provider v-slot="{errors}"
                                     :rules="question.mandatory ? 'required' : ''">
                <div :class="{isPopUp, 'list-attribute' : ''}">
                    <label :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}">
                        {{ question.question_text}}
                    </label>
                    <div :class="{' col-md-9 col-xs-8 ' : isInquiry}" >
                        <select v-model="question.value" class="new-inputs form-control" @click="updateSelection" multiple :name="name"
                        >
                            <option v-for="(question_option,index) of question.options"
                                    :selected="question_option && isSelected(question_option.id) ? true : false"
                                    :value="question_option.id">
                                {{
                                    question_option.option
                                }}
                            </option>
                        </select>
                    </div>

                    <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                </div>
                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                </validation-provider>
                <input type="hidden" :value="id" name="questions[]">
            </div>
        </validation-observer>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormList",
    props: {
        value: {
            type: Object,
            default() {
                return {}
            },
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question: {
                ...this.value,
                value: [],
            }
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }else{
                return `question_${this.question.update_booking_question_id}_0`;
            }

        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}[]`;
            }else{
                return `question_${this.question.update_booking_question_id}_0[]`;
            }
        }
    },
    methods: {
        updateSelection(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry(this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.listForm) {
                    let validated = await this.$refs.listForm.validate();
                    verify(validated)
                }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        isSelected(optionId) {
            // Check if the current optionId is in the array of selectedOptionIds
            if (this.question.answer_text){
                return this.question.answer_text.includes(optionId);
            }
            else {
                return false;
            }
        },

    },
    mounted() {
        this.addEventListeners()
        if (this.question && this.question.answer_text) {
            // Split the answer_text by comma and convert each part to a number
            this.question.value = this.question.answer_text.split(',').map(Number);
        } else {
            // Set question.value to an empty string if answer_text doesn't exist
            this.question.value = [];
        }
        // this.selected = this.retrieveSelected();
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners()
    }
}
</script>

<style scoped>
.list-attribute{
    margin: 0px -14px;
}

@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        width: 18%;
        margin-left: 15px !important;
    }
}



@media screen and (min-width: 1px) and (max-width: 428px) {
/*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        margin-left: 15px !important;
    }
}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        margin-left: 17px !important;
    }
}
</style>